// @flow
/* eslint pinterest/no-jquery-outside-of-render:0 */

import $script from 'app/common/lib/external/script.patched.js'; // eslint-disable-line import/extensions

// A facade for script.js.
const script = {};

/**
 * @param {Array.<string>|string} deps
 * @param {function()} readyCallback
 */
script.ready = function(deps: *, readyCallback: *) {
  $script.ready(deps, readyCallback);
};

/**
 * @param {Array.<string>} deps
 * @param {string} url
 * @param {string} id
 */
script.load = function(deps: *, url: *, id: *) {
  // consider prefetching: http://www.phpied.com/preload-cssjavascript-without-execution/
  script.ready(deps, () => {
    // script.js doesn't understand schemeless URLs.
    const isSchemeRelative = url.lastIndexOf('//', 0) === 0;
    if (isSchemeRelative) {
      url = window.location.protocol + url;
    }
    $script(url, id);
  });
};

/**
 * @param {string} id
 */
script.done = function(id: *) {
  $script.done(id);
};

export default script;
